import { observer } from 'mobx-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FormButtonBack } from 'shared/ui';
import styles from './email-confirmation-form.module.scss';
import { AppLinks } from 'app/router/consts/app-links.enum';
import { VerificationCodeEnum } from 'shared/types';
import { MailConfirmationInput } from 'features/index';

export const EmailConfirmationForm: React.FC = observer(() => {
  const navigate = useNavigate();
  const changeKey = (key: string, confirmedMail: string) => {
    navigate(
      AppLinks.PasswordChangeLink.replace(':key', key).replace(
        ':mail',
        confirmedMail
      )
    );
  };
  return (
    <div className={styles.password_edit}>
      <div className={styles.password_edit__content}>
        <div className={styles.password_edit__title}>Подтверждение почты</div>
        <div className={styles.password_edit__additional_text}>
          Для восстановления введите вашу почту. Вам будет выслан код для
          восстановления пароля.
        </div>
        <div className={styles.password_edit__inputs}>
          <div className={styles.inputs__input}>
            <MailConfirmationInput
              setKey={changeKey}
              type={VerificationCodeEnum.ACCOUNT_RESTORE}
            />
          </div>
        </div>
        <div className={styles.password_edit__buttons}>
          <div className={styles.buttons__button_back}>
            <FormButtonBack />
          </div>
        </div>
      </div>
    </div>
  );
});
